import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

import { WSStore } from "../../../services/remote/store/WSStore";
import { WSUsersInstance } from "../../../services/remote/users/WSUsers";
import { Card } from "../../components/card/Card";
import "./ManagerStyle.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

export const ManagerHomeScreen = () => {
  const storeInstance = WSStore.getInstance();
  const userInstance = WSUsersInstance;

  const [stats, setStats] = useState({
    stores: 0,
    users: 0,
    revenue: 0,
    orders: 0,
  });

  useEffect(() => {
    storeInstance.countStores().then((res) => {
      setStats((prevStats) => ({
        ...prevStats,
        stores: res,
      }));
    });

    userInstance.countUsers().then((res) => {
      setStats((prevStats) => ({
        ...prevStats,
        users: res,
      }));
    });
  }, []);

  const chartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Revenue (TND)",
        data: [12000, 19000, 15000, 22000, 30000, 48000],
        borderColor: "#4f46e5",
        backgroundColor: "rgba(79,70,229,0.2)",
        tension: 0.4,
      },
    ],
  };

  return (
    <div className="mc-dashboard">
      {/* HEADER */}
      <div className="mc-dashboard-header">
        <h1>Manager Dashboard</h1>
        <p>Overview of your platform performance</p>
      </div>

      {/* KPI CARDS */}
      <div className="mc-dashboard-grid">
        <Card
          title="Total Stores"
          value={stats.stores}
          description="Active stores on platform"
          trend="up"
          isManey={false}
          className="mc-card-info"
          icon={<span>🏪</span>}
        />

        <Card
          title="Total Users"
          value={stats.users}
          description="Registered users"
          trend="up"
          isManey={false}
          className="mc-card-success"
          icon={<span>👥</span>}
        />

        <Card
          title="Revenue"
          value={stats.revenue}
          description="Total earnings"
          trend="up"
          className="mc-card-warning"
          icon={<span>💰</span>}
        />

        <Card
          title="Orders"
          value={stats.orders}
          description="Total orders processed"
          trend="neutral"
          className="mc-card-neutral"
          icon={<span>📦</span>}
        />
      </div>

      {/* CHART SECTION */}
      <div className="mc-dashboard-chart">
        <div className="mc-chart-header">
          <h2>Revenue Analytics</h2>
        </div>

        <Line data={chartData} />
      </div>
    </div>
  );
};
